<template>
    <div class="company_box">
        <div class="company_detial">
            <div class="title">
                <div class="left_box">
                    <img :src="companyInfo?.logo" alt="" />

                    <div class="text_box">
                        <div class="name">{{ companyInfo?.name || "-" }}</div>
                        <div class="tip">{{ companyInfo?.staff_size || "-" }}·{{ companyInfo?.industry || "-" }}</div>
                    </div>
                </div>

                <div class="right">
                    <span> {{ tabData[1].number || 0 }} </span>
                    在招职位
                </div>
            </div>
        </div>

        <div class="content_box">
            <div class="tab_box">
                <div
                    class="tab"
                    :class="actievTabData == item.id ? 'active_tab' : ''"
                    v-for="item in tabData"
                    :key="item.id"
                    @click="changeItem(item.id)"
                >
                    {{ item.label }} <span v-if="item.number">({{ item.number }})</span>
                </div>
            </div>

            <CompanyProfile v-if="actievTabData == 1 && companyInfo" :company="companyInfo" />
            <RecruitmentPosition v-if="actievTabData == 2 && companyInfo" :company="companyInfo" />
            <EnterpriseTasks v-if="actievTabData == 3 && companyInfo" :company="companyInfo" />
            <SkillsTraining v-if="actievTabData == 4 && companyInfo" :company="companyInfo" />
        </div>
    </div>
</template>

<script>
import CompanyProfile from "../../../../components/recruitmentCenter/CompanyProfile.vue";
import EnterpriseTasks from "../../../../components/recruitmentCenter/EnterpriseTasks.vue";
import RecruitmentPosition from "../../../../components/recruitmentCenter/RecruitmentPosition.vue";
import SkillsTraining from "../../../../components/recruitmentCenter/SkillsTraining.vue";

export default {
    name: "HotVideo",
    components: {
        CompanyProfile,
        EnterpriseTasks,
        RecruitmentPosition,
        SkillsTraining,
    },
    data() {
        return {
            tabData: [
                {
                    id: 1,
                    label: "公司简介",
                    number: null,
                },
                {
                    id: 2,
                    label: "招聘职位",
                    number: null,
                },
                {
                    id: 3,
                    label: "企业任务",
                    number: null,
                },
                {
                    id: 4,
                    label: "技能训练",
                    number: null,
                },
            ],
            actievTabData: 1,
            companyInfo: undefined,
        };
    },

    created() {
        this.getCompanyDetial();
    },

    methods: {
        changeItem(id) {
            this.actievTabData = id;
        },

        getCompanyDetial() {
            let params = {
                id: this.$route.query.id,
            };
            this.$httpStudent.axiosGetBy(this.$api.jobCompanyDetail, params, (res) => {
                if (res.code == 200) {
                    this.companyInfo = res.data?.info;
                    this.tabData[1].number = res.data?.position_num || 0;
                    this.tabData[2].number = res.data?.company_task_num || 0;
                    this.tabData[3].number = res.data?.company_train_num || 0;
                }
            });
        },
    },
};
</script>

<style scoped lang="scss">
.company_box {
    width: 100%;
    padding-bottom: 20px;

    .company_detial {
        width: 100%;
        height: 148px;
        background: linear-gradient(90deg, #b9acff 0%, #6ba7d2 100%);
        border-radius: 0px 0px 0px 0px;
        padding: 19px 0;
        display: flex;
        justify-content: center;
        box-sizing: border-box;

        .title {
            width: 1184px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .left_box {
                width: 70px;
                height: 70px;
                border-radius: 12px 12px 12px 12px;
                display: flex;
                flex: 1;
                flex-shrink: 0;

                img {
                    width: 70px;
                    height: 70px;
                    border-radius: 12px 12px 12px 12px;
                    margin-right: 10px;
                }

                .text_box {
                    .name {
                        font-weight: bold;
                        font-size: 30px;
                        color: #ffffff;
                    }

                    .tip {
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 14px;
                        color: #ffffff;
                    }
                }
            }
            .right {
                font-weight: 400;
                font-size: 16px;
                color: #ffffff;
                span {
                    font-weight: bold;
                    font-size: 40px;
                    color: #ffffff;
                    margin-right: 5px;
                }
            }
        }
    }
    .content_box {
        width: 1184px;
        margin: 0 auto;

        .tab_box {
            width: 100%;
            margin-top: 20px;
            display: flex;
            align-items: center;
            background: #ffffff;
            border-radius: 12px 12px 12px 12px;

            .tab {
                margin: 0 20px 0 20px;
                padding: 11px 0 13px 0;
                font-weight: 500;
                font-size: 18px;
                font-weight: 400;
                font-size: 18px;
                color: #333333;
                cursor: pointer;
            }

            .active_tab {
                color: #685ef5;
                border-bottom: 2px solid #685ef5;
            }
        }
    }
}
</style>
